[
  {
    "code": "AF-BDS",
    "name": "Badakhshan"
  },
  {
    "code": "AF-BDG",
    "name": "Badghis"
  },
  {
    "code": "AF-BGL",
    "name": "Baghlan"
  },
  {
    "code": "AF-BAL",
    "name": "Balkh"
  },
  {
    "code": "AF-BAM",
    "name": "Bamian"
  },
  {
    "code": "AF-DAY",
    "name": "Daykondi"
  },
  {
    "code": "AF-FRA",
    "name": "Farah"
  },
  {
    "code": "AF-FYB",
    "name": "Faryab"
  },
  {
    "code": "AF-GHA",
    "name": "Ghazni"
  },
  {
    "code": "AF-GHO",
    "name": "Ghowr"
  },
  {
    "code": "AF-HEL",
    "name": "Helmand"
  },
  {
    "code": "AF-HER",
    "name": "Herat"
  },
  {
    "code": "AF-JOW",
    "name": "Jowzjan"
  },
  {
    "code": "AF-KAB",
    "name": "Kabol"
  },
  {
    "code": "AF-KAN",
    "name": "Kandahar"
  },
  {
    "code": "AF-KAP",
    "name": "Kapisa"
  },
  {
    "code": "AF-KHO",
    "name": "Khowst"
  },
  {
    "code": "AF-KNR",
    "name": "Konar"
  },
  {
    "code": "AF-KDZ",
    "name": "Kondoz"
  },
  {
    "code": "AF-LAG",
    "name": "Laghman"
  },
  {
    "code": "AF-LOW",
    "name": "Lowgar"
  },
  {
    "code": "AF-NAN",
    "name": "Nangarhar"
  },
  {
    "code": "AF-NIM",
    "name": "Nimruz"
  },
  {
    "code": "AF-NUR",
    "name": "Nurestan"
  },
  {
    "code": "AF-ORU",
    "name": "Oruzgan"
  },
  {
    "code": "AF-PIA",
    "name": "Paktia"
  },
  {
    "code": "AF-PKA",
    "name": "Paktika"
  },
  {
    "code": "AF-PAN",
    "name": "Panjshir"
  },
  {
    "code": "AF-PAR",
    "name": "Parwan"
  },
  {
    "code": "AF-SAM",
    "name": "Samangan"
  },
  {
    "code": "AF-SAR",
    "name": "Sar-e Pol"
  },
  {
    "code": "AF-TAK",
    "name": "Takhar"
  },
  {
    "code": "AF-WAR",
    "name": "Wardak"
  },
  {
    "code": "AF-ZAB",
    "name": "Zabol"
  }
]